import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import CommentInitialsBox from './CommentInitialsBox';
import MenuIcon from '@material-ui/icons/MoreHoriz';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';
import classnames from 'classnames';
import { formatCommentDateTime } from './helpers';
import { withNamespaces } from 'react-i18next';
import TypographyStyles from '../../../styles/typography';
import LayoutStyles from '../../../styles/layout';
import combineStyles from '../../../utils/combineStyles';
import SpacingStyles from './../../../styles/helpers/spacing';

const styles = theme => ({
  commentInfoContainer: {
    display: 'flex'
  },
  commentAuthor: {
    marginBottom: [theme.spacing.unit * 0.5, '!important']
  },
  commentTitleInfoContainer: {
    marginLeft: theme.spacing.unit * 2,
    flex: 1
  },
  commentMenuButton: {
    justifyContent: 'flex-end',
    alignContent: 'center',
    '&:hover': {
      backgroundColor: '#fff'
    }
  },
  edited: {
    marginLeft: theme.spacing.unit * 0.25
  }
});
export class CommentHeader extends PureComponent {
  static propTypes = {
    inEditMode: PropTypes.bool.isRequired,
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    changedUtc: PropTypes.string.isRequired,
    onDelete: PropTypes.func,
    comment: PropTypes.object.isRequired,
    users: PropTypes.array.isRequired,
    editable: PropTypes.bool.isRequired,
    deletable: PropTypes.bool.isRequired,
    onEditClick: PropTypes.func,
    isAdmin: PropTypes.bool.isRequired
  };
  state = {
    menuVisible: false,
    menuElement: null
  };
  toggleMenuVisibility = display => {
    this.setState({ menuVisible: display });
  };
  _handleMenuClick = event => {
    this.setState({ menuElement: event.currentTarget });
  };
  _handleMenuClose = () => {
    this.setState({ menuElement: null });
  };
  render() {
    const {
      classes,
      firstName,
      lastName,
      changedUtc,
      t,
      onDelete,
      inEditMode,
      editable,
      deletable,
      onEditClick,
      users,
      isAdmin,
      comment
    } = this.props;
    const { menuVisible, menuElement } = this.state;

    return (
      <Fragment>
        <div
          className={classes.commentInfoContainer}
          onMouseEnter={() => {
            this.toggleMenuVisibility(true);
          }}
          onMouseLeave={() => {
            this.toggleMenuVisibility(false);
          }}
        >
          <CommentInitialsBox firstName={firstName} lastName={lastName} />
          <div className={classes.commentTitleInfoContainer}>
            <h4
              className={classnames(classes.subtitle3, classes.commentAuthor)}
            >{`${firstName} ${lastName}`}</h4>
            <p className={classnames(classes.mediumWeight, classes.caption)}>
              {formatCommentDateTime(changedUtc)}
              {comment.wasEdited && (
                <span className={classes.edited}>({t('Edited')})</span>
              )}
            </p>
          </div>
          <div
            className={
              menuVisible && !inEditMode && (editable || deletable)
                ? classes.visible
                : classes.invisible
            }
          >
            <IconButton
              color="primary"
              disableRipple={true}
              onClick={this._handleMenuClick}
              classes={{
                root: classnames(
                  classes.noPadding,
                  classes.commentMenuButton,
                  classes.menuButton
                )
              }}
            >
              <MenuIcon />
            </IconButton>
          </div>
        </div>
        <Menu
          anchorEl={menuElement}
          open={Boolean(menuElement)}
          onClose={this._handleMenuClose}
        >
          {editable && (
            <MenuItem
              onClick={() => {
                onEditClick({ comment, users, isAdmin, editable });
                this._handleMenuClose();
              }}
            >
              {t('Edit')}
            </MenuItem>
          )}
          {deletable && (
            <MenuItem
              onClick={() => {
                onDelete(this.props.comment);
                this._handleMenuClose();
              }}
            >
              {t('Delete')}
            </MenuItem>
          )}
        </Menu>
      </Fragment>
    );
  }
}
const translatedCommentHeader = withNamespaces()(CommentHeader);
export default withStyles(
  combineStyles(TypographyStyles, styles, SpacingStyles, LayoutStyles)
)(translatedCommentHeader);
